import { useSDK } from '../store'

export const useConfig = () => {
  const sdk = useSDK()
  return sdk.config
}
